import React, {useEffect, useState} from "react"
import {useLocation} from "react-router-dom"
import {studentPaymentService} from "services"

type Status = "loading" | "success" | "error"

export const PaypalRevisionApproved: React.FC = () => {
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const subscriptionId = params.get("subscription_id") ?? ""

    const [status, setStatus] = useState<Status>("loading")
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        if (!subscriptionId) {
            setStatus("error")
            setErrorMessage("Missing subscription ID in the redirect URL.")
            return
        }

        studentPaymentService
            .confirmPaypalRevision(subscriptionId)
            .then(() => setStatus("success"))
            .catch((err) => {
                setStatus("error")
                setErrorMessage(err?.response?.data?.message ?? "Could not confirm the billing change.")
            })
    }, [subscriptionId])

    const containerStyle: React.CSSProperties = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: "sans-serif",
        gap: 16,
        padding: 32,
        textAlign: "center"
    }

    const headingStyle: React.CSSProperties = {fontSize: 22, fontWeight: 600, margin: 0}
    const subStyle: React.CSSProperties = {color: "#555", margin: 0}
    const btnStyle: React.CSSProperties = {
        marginTop: 8,
        padding: "8px 20px",
        fontSize: 14,
        cursor: "pointer",
        border: "1px solid #d9d9d9",
        borderRadius: 4,
        background: "#fff"
    }

    if (status === "loading") {
        return (
            <div style={containerStyle}>
                <p style={headingStyle}>Confirming billing change…</p>
                <p style={subStyle}>Please wait while we sync your subscription with PayPal.</p>
            </div>
        )
    }

    if (status === "error") {
        return (
            <div style={containerStyle}>
                <p style={{...headingStyle, color: "#cf1322"}}>Could not confirm billing change</p>
                <p style={subStyle}>{errorMessage}</p>
                <p style={subStyle}>
                    The change may still be processed automatically. You can close this tab and use the{" "}
                    <strong>Sync</strong> button on the recurring payment to refresh the status.
                </p>
                <button style={btnStyle} onClick={() => window.close()}>
                    Close tab
                </button>
            </div>
        )
    }

    return (
        <div style={containerStyle}>
            <p style={{...headingStyle, color: "#389e0d"}}>Billing change approved!</p>
            <p style={subStyle}>Your subscription has been updated. You can close this tab and return to the portal.</p>
            <button style={btnStyle} onClick={() => window.close()}>
                Close tab
            </button>
        </div>
    )
}
